import React, { useEffect, useState, useRef } from 'react';
import { Table, Button, Dialog, Input, Form, DatePicker, Message, Card, Pagination, Select, TimePicker, CascaderSelect, Radio ,Balloon} from '@alifd/next';
import styles from './index.module.scss';
import client from '../../../../lib/feathers';
import moment from 'moment';
import axios from "axios";
import ezconImg from "../../../../../public/ezcon.png";
const { Item } = Form;
const Option = Select.Option;
const RadioGroup = Radio.Group;
const SmartMailList = (props) => {


  const [usersArr, setUsersArr] = useState([]);
  const baEvent = client.service('baEvent');
 
  useEffect(() => {
    try {
      const residentAccountNumbers = client.service('residentAccountNumbers');
      residentAccountNumbers.find({}).then((res) => { setUsersArr(res.data) })
    } catch
    (error) {
      console.log("未連接server:err", error)
    }

  }, []);


  const openMail = (record)=>{
    // console.log("record",record)

    axios(`/ezcon/api/ba/event?事件名稱=開啟信箱&信箱=${record.mailNumber}`, {
      method: "GET",
      headers: { authorization: window.localStorage['feathers-jwt'] },
    
    }).then((res) => {
      console.log('==send openMailBox Success:', res);

    }).catch(error => {
      console.error('==send openMailBox fail:', error);

    })

  }

  const findMail = (record)=>{

    if(record.householdNumber){
      const DAY_MS = 24 * 60 * 60 * 1000 * 365;
      baEvent.find({
        query:{
          householdNumbers:record.householdNumber,
          title:"信箱投信",
          createdTime: {
            $gt: moment().startOf('day').valueOf(), //今天之後 
            $lt: moment().valueOf() + DAY_MS,//以今天計算+365天
  
          },

        }
      }).then((res)=>{
        console.log("==find baEvent success",res.data)
        if(res.data&&res.data.length>0){
          Message.success(`查詢成功，共${res.data.length}筆資訊`) 
        }else{
          Message.success(`查詢成功，尚未有投信資訊`)  
        }
        
      }).catch((error)=>{
        console.log("==find baEvent fail",error)
        // Message.error("尚未開通戶號") 
      })
    }else{
      Message.error("尚未開通戶號") 
    }
 

  }


  return (
    <Card free>
      <Card.Content>
        <Table dataSource={usersArr}>
          <Table.Column title="戶號" dataIndex="householdNumber" width={200} />
          <Table.Column title="用戶名" dataIndex="userName" width={200} />
          <Table.Column title="地址" dataIndex="address" width={200} />
          <Table.Column title="信箱號碼" dataIndex="mailNumber" width={200} />
          <Table.Column
            title="操作"
            width={300}
            lock="right"
            cell={(value, index, record) => {
              // console.log('==op ', value, index, record);
              return (
                <div className={styles.btn}>
                  <Button
                    type="primary"
                    onClick={() => {
                      openMail(record);
                    }}
                  >
                    開啟信箱
                  </Button>
                  <Balloon
                    trigger={
                      <Button
                        type="normal"
                        onClick={() => {
                          findMail(record);
                        }}
                      >
                        查看投信狀態
                      </Button>
                    }
                    closable={false}
                  >
                    查詢當日之後投信狀態
                  </Balloon>
                </div>
              );
            }}
          ></Table.Column>
        </Table>
      </Card.Content>
    </Card>
  );
     




};

export default SmartMailList;
